import { useSelector } from "react-redux";
import { subModPermissionSelector } from "../../../store/features/permissions/permissionsSlice";
import { R_PROJECTS, R_PROJECTS_LIST } from "../../../../utils/permissionReferenceConfig";
import Layout from "../../../Components/Layout";
import AddForm from "../EmployeeDetail/AddForm";

export default function NewEmployee() {
  const { canView } = useSelector(subModPermissionSelector(R_PROJECTS, R_PROJECTS_LIST));
  return (
    <Layout canView={canView}>
      <AddForm />
    </Layout>
  )
}